import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import CharityLocationsMap from '../CharityLocationsMap'
import styles from './CharityProfileMain.module.scss'

export default function CharityProfileMain({ charity, locationLabel }) {
  const { t } = useTranslation()
  const hasLocationPins = !!(
    charity?.volunteer_location ||
    charity?.donation_location ||
    charity?.visitor_location
  )

  if (!hasLocationPins) {
    return null
  }

  return (
    <div className={styles.main}>
      <section className={styles.section}>
        <div className={styles.communityTitleRow}>
          <h3 className={styles.sectionTitle}>
            {t('charities.profile.locations', 'Locations')}
            {locationLabel ? (
              <>
                : <span className={styles.communityLocation}>{locationLabel}</span>
              </>
            ) : null}
          </h3>
        </div>
        <hr className={styles.divider} />
        <CharityLocationsMap charity={charity} />
      </section>
    </div>
  )
}

CharityProfileMain.propTypes = {
  charity: PropTypes.object,
  locationLabel: PropTypes.string,
}
